import { Button, createStyles, makeStyles, styled, Theme } from '@material-ui/core';
import StyledDialog from 'shared/elements/StyledDialog/StyledDialog';

export const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',

      '& .MuiOutlinedInput-root': {
        height: '50px!important',
        fontSize: 14,
        background: '#0e1319',
      },

      '& .MuiFormLabel-root': {
        display: 'flex',
        justifyContent: 'space-between',
        fontSize: '13px',
        letterSpacing: '1px',
        alignItems: 'center',
        color: '#c2ccd8',

        '& .MuiBox-root': {
          padding: '2px 4px 1px 5px',
          border: '1px solid',
          borderRadius: '100%',
          fontSize: '12px',
        },
      },

      '& .MuiSelect-iconOutlined': {
        right: '0',
        top: '22px',
      },

      '& .MuiSelect-iconOpen': {
        top: '2px',
        right: '13px',
      },
    },
    header: {
      marginBottom: 40,
      textAlign: 'center',
      width: 357,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      [theme.breakpoints.down(960)]: {
        marginBottom: 30,
      },
    },
    form: {
      display: 'flex',
      flexDirection: 'column',
      gap: 15,
      padding: '0 12px',
      marginBottom: 40,
    },

    noLabelFix: {
      marginTop: 0,
    },
    selectNoLabelFix: {
      marginTop: '-17px',
    },
    input: {
      maxWidth: 450,
      background: 'none',
      borderRadius: 8,
      fontWeight: 400,
      '& input': {
        fontSize: 14,
      },
      '& .MuiInputBase-root': {
        paddingLeft: 20,
        borderRadius: 8,
      },
    },
    startIcon: {
      fontSize: 20,
      marginRight: 5,
    },
    helpText: {
      color: '#60718b',
      textAlign: 'left',
      maxWidth: 390,
    },
    autocompleteFix: {
      '& .MuiInputBase-input': {
        paddingTop: '8px!important',
      },
    },
    chips: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      background: '#28313f',
      height: 50,
      borderRadius: 5,
      padding: '0 20px',

      '&:not(:first-child)': {
        marginTop: 10,
      },

      '& .MuiSvgIcon-root': {
        cursor: 'pointer',
        fontSize: 18,
        '& path': {
          fill: '#d83032',
        },
      },
    },
  }),
);

export const TwoColumn = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: 7,
  maxWidth: 333,

  [theme.breakpoints.down('xs')]: {
    flexDirection: 'column',
    marginBottom: 5,
  },

  '& > div': {
    flex: '50%',
  },

  '& .MuiFormControl-root': {
    marginTop: 0,
  },
}));

export const AddNewUnionButton = styled(Button)({
  marginTop: 10,
  height: '50px !important',

  background: '#0e1319',
  border: '1px solid #2d343e',
});

export const CustomDialog = styled(StyledDialog)<Theme>(() => ({
  '&.paper': {
    minWidth: '85%',
    minHeight: '90%',
  },
  '& .MuiDialog-paperWidthSm': {
    maxWidth: '485px !important',
    // minHeight: type === 'contact' ? 800 : 720,
  },
}));
